import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'alumni-card',
  name: '校友名片',
  icon: '友',
  group: '校友会组件',
  description: '展示当前校友身份、认证状态和名片入口。',
  defaultProps: {
    title: '校友名片',
    subtitle: '完善资料，点亮校友身份',
    link: '/pages/alumni/card'
}
}
